import React, {Component} from 'react';

import '../sass/cgu.scss';

import Footer from '../components/Footer';
import CguText from '../components/cgu/CguText';

import {getLocale, dt} from 'l10n';
import {Helmet} from "react-helmet";

class Cgu extends Component {

    constructor(props) {
        super(props);

        this.state = {};

    }

    render() {

        return (
            <div id="wrapper" className="cgu-wrapper">
                <Helmet>
                    <title>
                        {dt('meta', 'The general conditions of use of Bob’s sites')}
                    </title>
                    <meta name="description" content={dt('meta', 'Read the regulations, conditions of use and legal information of BobTV, Bobvoyeur and Bob4men (CGU).')}/>
                </Helmet>
                <CguText lang={getLocale()} />
            </div>
        )
    }
}

export default Cgu;



// WEBPACK FOOTER //
// ./src/containers/Cgu.js